import React from "react";
import Header from "../../Component/Util/Header";
import Footer from "../../Component/Util/Footer";
import ChildPesananProduk from "../../Component/Child Pesanan Produk/ChildPesananProduk";

export default function PesananProduk() {
  return (
    <>
      <Header />

      <ChildPesananProduk />
      <Footer />
    </>
  );
}
